<template>
    <div class="main-side">
        <div class="button-list">
            <div class="button" id="backtop" @click="backTop">
                <img class="button-icon" src="../../images/icon/right_icon__top_blue.png">
            </div>
            <div class="button">
                <div class="side-img-div">
                    <div class="side-content">
                        <div class="contact-div">
                            <h5>投诉渠道</h5>
                            <img src="../../images/icon/web_icon_complaint.png"/>
                            <div class="contact-font">
                                <p class="p1">投诉服务联系方式</p>
                                <p class="p2">400-000-0056</p>
                            </div>
                            
                        </div>
                    </div>
                    <div class="arrow"></div>
                </div>
                <img class="button-icon" src="../../images/footer-side/right_phone_blue.png">
            </div>
            <div class="button">
                <div class="side-img-div">
                    <div class="side-content content-QRcode">
                        <div class="qt-title">资讯&服务</div>
                        <div class="flex">
                            <div class="qts-div">
                            <img class="button-qt" src="../../images/footer-side/code_wechat.jpg">
                            <span>微信公众号</span>
                        </div>
                        <div class="qts-div">
                            <img class="button-qt" src="../../images/footer-side/code_ztb.jpg">
                            <span>直通宝APP</span>
                        </div>
                        <div class="qts-div">
                            <img class="button-qt" src="../../images/footer-side/code_weui.png">
                            <span>直通宝小程序</span>
                        </div>
                        </div>
                        
                    </div>
                    <div class="arrow"></div>
                </div>
                <img class="button-icon" src="../../images/icon/right_code_blue.png">
            </div>
            <div class="button">
                <router-link to="/">
                    <img class="button-icon" src="../../images/icon/right_home_blue.png">
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'main-side',
    data() {
        return {
            menu: [],
            isMobile: this.COMMON.isMobile,
            QRcode: false,
            image: '',
            imageName: ''
        };
    },
    methods: {
        backTop() {
            let distance =
                document.documentElement.scrollTop || document.body.scrollTop;
            let step = distance / 50;
            (function jump() {
                if (distance > 0) {
                    distance -= step;
                    setTimeout(window.scrollTo(0, distance), 100);
                    setTimeout(jump, 7);
                }
            })();
        },
        clickTr(e, name) {
            e.preventDefault();
            this.showDetail(name);
        },
        showDetail(name) {
            document.body.style.overflow = 'hidden';
            if (name === 1) {
                this.imageName = '微信公众号';
                this.image = require('../../images/picture/wechat_code.png');
            } else {
                this.imageName = '微信小程序';
                this.image = require('../../images/picture/weui_code.png');
            }
            this.QRcode = true;
        },
        closeDetail() {
            document.body.style.overflow = 'auto';
            this.QRcode = false;
        }
    },
    mounted() {
        window.onscroll = function() {
            if (
                document.documentElement.scrollTop + document.body.scrollTop >
                100
            ) {
                document.getElementById('backtop').style.opacity = 1;
                document.getElementById('backtop').style.cursor = 'pointer';
            } else {
                document.getElementById('backtop').style.opacity = 0;
                document.getElementById('backtop').style.cursor = 'initial';
            }
        };
    }
};
</script>

<style lang="less">
.main-side {
    .button-list {
        position: fixed;
        bottom: 3rem;
        right: 0.3rem;
    }
    .button {
        height: 0.5rem;
        width: 0.5rem;
        background-color: #ffffff;
        box-shadow: 0px 0px 4px 0px rgba(90, 90, 90, 0.1);
        margin-bottom: 0.08rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .button-icon {
            filter: grayscale(1);
            -ms-filter: grayscale(100%);
            filter: gray;
            width: 0.25rem;
            height: 0.25rem;
            opacity: 0.6;
        }
    }
    #backtop{
        transition: opacity 0.3s;
        -webkit-transition: opacity 0.3s;
        cursor: pointer;
    }
    .button:hover {
        .button-icon {
            opacity: 1;
            filter: none;
        }
    }

    .side-img-div {
        visibility: hidden;
        position: relative;
    }
    .side-content {
        position: absolute;
        width: 2.5rem;
        height: 1.2rem;
        background-color: #ffffff;
        top: 50%;
        left: 50%;
        margin-top: -0.8rem;
        margin-left: -3.2rem;
        padding: 0.2rem;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        h5 {
            font-size: 0.16rem;
            margin-bottom: 0.23rem;
        }
        .p1 {
            color: #999999;
            margin-bottom: 0.05rem;
        }
        .p2 {
            font-size: 0.2rem;
            color: #ff8800;
        }
    }
    .arrow {
        height: 0.15rem;
        width: 0.15rem;
        transform: rotate(45deg);
        background: #ffffff;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.07rem;
        margin-left: -0.38rem;
        box-shadow: 3px -3px 8px 0px rgba(0, 0, 0, 0.1);
    }
    .content-QRcode {
        height: 1.4rem;
        width: 3.4rem;
        margin-top: -1rem;
        margin-left: -4.1rem;
        .flex{
            display: flex;
            justify-content: space-between;
        }
    }
    .qt-title{
        text-align: left;
        padding-left: 0.1rem;
    }
    .button-qt {
        width: 1rem;
        display: block;
    }
    .qts-div {
        text-align: center;
    }
    .contact-font {
        display: inline-block;
        margin-left: 10px;
    }
    .contact-div{
        display: inline-block;
        margin-right: 0.2rem;
        text-align: center;
    }
    .contact-div:nth-child(1){
        text-align: left;
        vertical-align: top;
        padding: 0.1rem 0 0 0.1rem;
    }
    .contact-div:nth-child(3){
        margin-right: 0;
    }
    .button-contact{
        width: 1rem;
        display: block;
    }
    .button:hover {
        .side-img-div {
            visibility: visible;
        }
    }
}

@media screen and (min-width: 481px) and (max-width: 959px) {
    .main-side{
        .side-img-div  {
            .contact-div {
                margin-right: 0.1rem;
            }
        }
    }
}
</style>
